<template>
  <div>
    <b-card class="d-none d-sm-block">
      <b-table
        v-model="currentItems"
        :per-page="perPage"
        :current-page="currentPage"
        responsive
        :items="items"
        :fields="fields"
        class="mb-0 account-expenses-table"
      >
        <template v-slot:cell(actions)="{ detailsShowing, item }">
          <b-button
            class="detail-btn"
            @click="getRowDetail(item)"
          >
            <feather-icon
              v-if="detailsShowing"
              icon="ChevronUpIcon"
              size="21"
            />
            <feather-icon
              v-else
              icon="ChevronDownIcon"
              size="21"
            />
          </b-button>
        </template>
        <template v-slot:row-details="">
          <b-card>
            <b-table
              id="detail-table"
              responsive
              :items="detailsItems"
              :fields="detailsFields"
              class="mb-0"
            />
          </b-card>
        </template>
      </b-table>
      <b-pagination
        v-if="items && items.length > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-1"
      />
    </b-card>
    <!--  mobile size  -->
    <b-card
      v-if="items && items.length"
      class="d-block d-sm-none"
      no-body
    >
      <!--      new mobile size table      -->
      <b-card-body class="p-1">
        <div
          v-for="(item,index) in items"
          :key="index"
          class="expense-item p-0"
          @click="setExpenseDetailModal(item)"
        >
          <div class="expense-row">
            <b-media no-body>
              <b-media-body>
                <h6 class="mb-0 transaction-title">
                  {{ item.expense_category_name }}
                </h6>
                <small class="text-secondary">{{ item.detail.length }} ردیف</small>
              </b-media-body>
            </b-media>

            <div class="d-flex font-weight-bolder pl-1">
              {{ item.locale_expense_fee_sum }}
              <img
                :src="require('@/assets/icons/eye.svg')"
                alt=""
                draggable="false"
                width="20"
                height="20"
                class="icon icon-tabler icon-tabler-eye ml-1"
              >
            </div>
          </div>
          <hr v-if="index !== items.length-1">
        </div>
      </b-card-body>
      <!--      new mobile size table      -->
    </b-card>

    <EmptyResult
      :list="items"
      text="هیچ هزینه‌ای جهت نمایش وجود ندارد"
    />

    <!--  mobile size  -->
    <b-modal
      id="modal-default"
      hide-footer
      hide-header-close
      centered
      :title="selectedExpense ? selectedExpense.expense_category_name : ''"
    >
      <div class="p-1" />
      <div
        v-if="selectedExpense && selectedExpense.detail.length"
      >
        <div
          v-for="(item,index) in selectedExpense.detail"
          :key="index"
          class="expense-detail-item"
        >
          <b-media
            no-body
            class="p-0"
          >
            <b-media-body>
              <h6 class="mb-0 transaction-title">
                {{ item.expense_name }}
              </h6>
              <small class="text-secondary">{{ item.locale_expense_date }}</small>
            </b-media-body>
            <div class="pl-1 font-weight-bolder">
              {{ item.locale_expense_fee }}
            </div>
          </b-media>
          <hr v-if="index !== selectedExpense.detail.length-1">
        </div>

      </div>
      <b-button
        class="d-block mx-auto mt-2 px-3"
        size="md"
        variant="primary"
        @click="$bvModal.hide(`modal-default`)"
      >
        بستن
      </b-button>
    </b-modal>
  </div>

</template>

<script>
import {
  BCard, BCardBody, BCardText, BLink, BAlert, BRow, BCol, BTable, BPagination, BButton, BModal, BMedia, BMediaBody,
} from 'bootstrap-vue'
import axios from '@/libs/axios'
import userService from '@/api/userService'
import EmptyResult from '@/@core/components/empty-result/EmptyResult.vue'

export default {
  name: 'AccountExpenses',
  components: {
    BMediaBody,
    BCard,
    BCardBody,
    BCardText,
    BLink,
    BAlert,
    BRow,
    BCol,
    BTable,
    BPagination,
    BButton,
    BModal,
    BMedia,
    EmptyResult,
  },
  data() {
    return {
      selectedExpense: null,
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      fields: [],
      items: null,
      mobileFields: [
        { key: 'actions' },
        { key: 'client' },
      ],
      mobileItems: [],
      detailsFields: [],
      detailsItems: [],
      currentItems: [],
    }
  },
  mounted() {
    this.getExpenses()
    this.token = sessionStorage.getItem('token') || localStorage.getItem('token')
  },
  methods: {
    getExpenses() {
      userService.expenses()
        .then(response => {
          this.items = response.data.list
          this.items.forEach(item => {
            this.mobileItems.push({
              client: item,
            })
          })
          const headers = response.data.header
          Object.entries(headers).forEach(ent => {
            this.fields.push({
              key: ent[0],
              label: ent[1],
            })
          })
          this.fields.push(
            {
              key: 'actions',
              label: 'جزئیات',
            },
          )
          this.totalRows = this.items.length
        })
    },
    setExpenseDetailModal(item) {
      this.selectedExpense = item
      this.$bvModal.show('modal-default')
    },
    getRowDetail(row) {
      axios
        .get('//api.sharjmaster.com/api/v1/expense/detail', {
          params: {
            expense_category_id: row.expense_category_id,
          },
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then(response => {
          this.detailsItems = response.data.data
          const headers = response.data.header
          Object.entries(headers).forEach(ent => {
            this.detailsFields.push({
              key: ent[0],
              label: ent[1],
            })
          })
          if (row._showDetails) {
            this.$set(row, '_showDetails', false)
          } else {
            this.currentItems.forEach(item => {
              this.$set(item, '_showDetails', false)
            })

            this.$nextTick(() => {
              this.$set(row, '_showDetails', true)
            })
          }
        })
        .finally(() => {})
    },
  },
}
</script>

<style>
.expense-detail-header {
    text-align: center;
    background-color: #e2e2ef;
    padding: 15px;
}
.expense-detail-item > div{
    display: flex;
    justify-content: space-between;
    padding: 15px 10px;
}
/* .expense-detail-item:nth-child(even),
.expense-item:nth-child(odd) {
    background-color: #f3f3f3;
}
body.dark-layout .expense-detail-item:nth-child(even),
body.dark-layout .expense-item:nth-child(odd) {
    background-color: #47516b;
} */
.expense-row {
    display: flex;
    justify-content: space-between;
}
.expense-item {
    cursor: pointer;
    padding: 15px 10px;
}
[dir=rtl] .table.b-table.account-expenses-table.b-table-stacked > tbody > tr > [data-label]::before {
  float: right;
  padding: 0 0 0 calc(1rem / 2);
  text-align: inherit;
}
[dir=rtl] .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
  float: right;
  text-align: right;
  padding: 0 0 0 calc(1rem / 2);
}
svg.feather.feather-chevron-up {
  color: #7367f0 !important;
}

svg.feather.feather-chevron-down {
  color: #7367f0 !important;
}

[dir] .btn-secondary:hover:not(.disabled):not(:disabled) {
  box-shadow: none !important;
}

[dir] .btn-secondary:focus, [dir] .btn-secondary:active, [dir] .btn-secondary.active {
  background-color: white !important;
}

.detail-btn {
  background-color: transparent !important;
  border: none !important;
}
.show-detail-mobile .detail-btn svg.feather.feather-plus{
  color: #7367f0;
}
[dir] .btn-secondary:focus, [dir] .btn-secondary:active, [dir] .btn-secondary.active {
  background-color: transparent !important;
}
</style>
